import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'startContainer',
    `
		display: flex;
		justify-content: center;
		margin: 30px auto;
	`
  ],
  [
    'start',
    `
		width: 300px;
	`
  ]
]);
